import { render, staticRenderFns } from "./test_main_mobile.vue?vue&type=template&id=6bcbb3b8&scoped=true"
import script from "./test_main_mobile.vue?vue&type=script&lang=js"
export * from "./test_main_mobile.vue?vue&type=script&lang=js"
import style0 from "./test_main_mobile.vue?vue&type=style&index=0&id=6bcbb3b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcbb3b8",
  null
  
)

export default component.exports